export {I18nProvider, useLocale, isRTL} from 'react-aria/I18nProvider';
export type {I18nProviderProps, Locale} from 'react-aria/I18nProvider';
